<button class="filter-action" (click)="onButtonClicked(buttonConfig.name)"
    [disabled]="isDisabled || isLoading"
    [class.filter-action--search]="buttonConfig.name.toLowerCase() === 'search' || buttonConfig.name.toLowerCase() === 'yes'
     || buttonConfig.isPrimary"
    [class.filter-action--reset]="buttonConfig.name.toLowerCase() === 'reset' || buttonConfig.name.toLowerCase() === 'no'"
    [ngStyle]="(buttonConfig && buttonConfig.buttonStyle)?buttonConfig.buttonStyle: ''">
    @if(isLoading && buttonConfig.name.toLowerCase() === 'search'){
        <span class="button-loader" aria-hidden="true"></span>
    }
    @if(buttonConfig['iconClass']){
        <i [ngClass]="buttonConfig['iconClass']">&nbsp;</i>
    }
    {{(buttonConfig && buttonConfig.name)?buttonConfig.name:ButtonDisplayValue.default|camelCase}}
</button>